import * as api from "../constants/api";
import axios from "../services/axios";
import { getErrorMessageFromAxiosError } from "../utils/axiosUtils";
import { addFlashMessage } from "./FlashMessagesAction";

export const GET_INNSYN_PERSONOPPLYSNINGER = "GET_INNSYN_PERSONOPPLYSNINGER";

export function getInnsynByEmail(email) {
  return async (dispatch) => {
    return axios
      .get(api.GET_INNSYN_BY_EMAIL_URL(email))
      .then((response) => {
        dispatch({
          type: `${GET_INNSYN_PERSONOPPLYSNINGER}_SUCCESS`,
          payload: {
            ...response.data,
            noResult: false,
            hasBeenSubmitted: true,
          },
        });
        return Promise.resolve(response);
      })
      .catch((error) => {
        if (error.response?.status === 404) {
          dispatch({
            type: `${GET_INNSYN_PERSONOPPLYSNINGER}_SUCCESS`,
            payload: { noResult: true, hasBeenSubmitted: true },
          });
          return Promise.resolve(null);
        }
        const errText = getErrorMessageFromAxiosError(error);
        dispatch(
          addFlashMessage({
            type: "error",
            text: (typeof errText === "string" && errText) || error.message,
          }),
        );
        return Promise.reject(error);
      });
  };
}
